import React from "react";
import Login from "../pages/Login";
import CreateAccountForm from "./CreateAccountForm";

const AuthChoice = ({ loginForm, handleAlreadyPartner }) => {
  return (
    <>
      {loginForm ? (
        <Login
          handleAlreadyPartner={handleAlreadyPartner}
        />
      ) : (
        <CreateAccountForm handleAlreadyPartner={handleAlreadyPartner} />
      )}
    </>
  );
};

export default AuthChoice;
